// extracted by mini-css-extract-plugin
export default {"btnMoveTo":"MoveToPosition_btnMoveTo__AFh6t","currentPositionInput":"MoveToPosition_currentPositionInput__R2xuR","disabled":"MoveToPosition_disabled__ajkl8"};